import React, { useState, useEffect, useContext } from "react";
import "./index.css";
import { icons } from "./menuJson";
import RButton from "../components/RButton";
import { Switch, Select, Slider, message } from "antd";
import RSwitch from "../components/RSwitch";
import RColorPicker from "../components/RColorPicker";
import { ThemeContext } from "../../App1";
import Draggable from "react-draggable";
import { useSelector, useDispatch } from "react-redux";
import {
  setEditVisible,
  setTreeVisible,
  setSkyVisible,
  setSceneVisible,
  setViewVisible,
  setVrVisible,
  setMeasureVisible,
  setCreateModelVisible,
  setEditType,
  setTreeList,
  setActiveTreeNodeId,
  setMeasureList,
  setUnit,
  setMVisible,
  setSkyInfo,
  setActiveView,
  setActiveModelIndex,
  setVrData,
} from "../../store/module/app";

const viewList = [
  { id: "default", label: "透视图", icon: "perspective" },
  {
    id: "top",
    label: "顶视图",
    icon: "top",
  },
  { id: "front", label: "前视图", icon: "front" },
  { id: "right", label: "右视图", icon: "right" },
  {
    id: "back",
    label: "后视图",
    icon: "back",
  },
  { id: "left", label: "左视图", icon: "left" },
];

const createModelList = [
  { id: "cube", label: "立方体", icon: "cube", index: 0 },
  { id: "ball", label: "球", icon: "ball", index: 1 },
  { id: "cylinder", label: "圆柱体", icon: "cylinder", index: 3 },
  { id: "capsule", label: "胶囊体", icon: "capsule", index: 2 },
  { id: "plane", label: "平面", icon: "plane", index: 4 },
];

const weatherList = [
  { id: "sun", label: "晴", icon: "sun" },
  { id: "fog", label: "雾", icon: "fog" },
  { id: "rain", label: "雨", icon: "rain" },
  { id: "snow", label: "雪", icon: "snow" },
];

function RightMenu(props) {
  let { webJson, editor } = useContext(ThemeContext);
  const { type, setType } = props;

  const {
    editVisible,
    treeVisible,
    skyVisible,
    sceneVisible,
    viewVisible,
    vrVisible,
    measureVisible,
    createModelVisible,
    editType,
    treeList,
    activeTreeNodeId,
    measureList,
    unit,
    mVisible,
    skyInfo,
    activeView,
    activeModelIndex,
    vrData,
  } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  // const editVisible = app.editVisible
  // const editType = app.editType
  // const treeList = app.treeList
  // const measureList = app.measureList

  // const [type, setType] = useState('sky')

  // 菜单项可见性
  // const [treeVisible, setTreeVisible] = useState(false) //对象树
  // const [skyVisible, setSkyVisible] = useState(false) //天空
  // const [sceneVisible, setSceneVisible] = useState(false) //场景
  // const [viewVisible, setViewVisible] = useState(false) //视图
  // const [vrVisible, setVrVisible] = useState(false) //VR设置
  // const [measureVisible, setMeasureVisible] = useState(false) //测量
  // const [createModelVisible, setCreateModelVisible] = useState(false) //创建模型

  const [activeTypes, setActiveTypes] = useState([]); //打开的菜单项

  // 对象树
  // const [treeList, setTreeList] = useState([// {nodeId: 1, name: '开关1', modelId: '', visible: true}
  // ])
  // const [activeTreeNodeId, setActiveTreeNodeId] = useState('')

  // 天空
  // const [skyInfo, setSkyInfo] = useState({ //天空属性
  //   sunAngle: 0, weather: 'sun', ambientIntensity: 0, ambientColor: '#FFFFFF', fogDensity: 0, fogColor: '#FFFFFF'
  // })
  // 视图
  // const [activeView, setActiveView] = useState('default')
  // VR设置
  // const [vrData, setVrData] = useState({
  //   enabled: false, floor_enabled: false, floor_color: '#FFFFFF', position_enabled: false
  // })
  // 测量
  // const [unit, setUnit] = useState('m')
  const [selectExpanded, setSelectExpanded] = useState(false);
  // const [mVisible, setMVisible] = useState(true)

  // const [measureList, setMeasureList] = useState([{
  //   id: "1", name: "距离测量1", distance: 100.51646, visible: true,
  // }])

  // 创建模型
  // const [activeModelIndex, setActiveModelIndex] = useState(0)

  // 取色器蒙板
  const [showColorPickerOverlay, setShowColorPickerOverlay] = useState(false);
  const [activeColorPickerId, setActiveColorPickerId] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  const getCurrentPanelState = () => {
    return {
      editVisible,
      treeVisible,
      skyVisible,
      sceneVisible,
      viewVisible,
      vrVisible,
      measureVisible,
      createModelVisible,
    };
  };

  const handleClickMenuItem = (item) => {
    // console.log(item)
    if (item.id === "scene") {
      return messageApi.open({ type: "warning", content: "功能正在开发中..." });
    }

    const oldPanelState = getCurrentPanelState();
    const newPanelState = getCurrentPanelState();

    // eslint-disable-next-line default-case
    switch (item.id) {
      // 编辑区
      case "edit":
        // setType('edit')
        newPanelState.editVisible = !newPanelState.editVisible;
        dispatch(setEditVisible(!editVisible));
        if (editVisible) {
          // 关闭
          dispatch(setEditType(""));
          editor.setClickMode(0);
        } else {
          // 打开
          dispatch(setEditType("scene"));
          editor.setClickMode(2);
          // 关闭互斥页面UI
          if (viewVisible) {
            dispatch(setViewVisible(false));
            newPanelState.viewVisible = false;
          }
          if (vrVisible) {
            dispatch(setVrVisible(false));
            newPanelState.vrVisible = false;
          }
          if (measureVisible) {
            dispatch(setMeasureVisible(false));
            newPanelState.measureVisible = false;
          }
          if (createModelVisible) {
            dispatch(setCreateModelVisible(false));
            newPanelState.createModelVisible = false;
          }
        }
        break;

      // 对象树
      case "tree":
        newPanelState.treeVisible = !newPanelState.treeVisible;
        const tree_visible = treeVisible;
        dispatch(setTreeVisible(!tree_visible));
        if (!tree_visible) {
          handleGetTreeList();
        }
        break;

      // 天空
      case "sky":
        newPanelState.skyVisible = !newPanelState.skyVisible;
        const sky_visible = skyVisible;
        dispatch(setSkyVisible(!skyVisible));
        if (!sky_visible) {
          handleGetSkyInfo();
        }
        break;

      // 视图
      case "change":
        newPanelState.viewVisible = !newPanelState.viewVisible;
        const view_visible = viewVisible;
        dispatch(setViewVisible(!view_visible));
        if (!view_visible) {
          //打开 - 关闭互斥页面UI
          if (editVisible) {
            newPanelState.editVisible = false;
            dispatch(setEditVisible(false));
            dispatch(setEditType(""));
          }
          if (vrVisible) {
            newPanelState.vrVisible = false;
            dispatch(setVrVisible(false));
          }
          if (measureVisible) {
            newPanelState.measureVisible = false;
            dispatch(setMeasureVisible(false));
          }
          if (createModelVisible) {
            newPanelState.createModelVisible = false;
            dispatch(setCreateModelVisible(false));
          }
        }
        break;

      // VR设置
      case "vr":
        newPanelState.vrVisible = !newPanelState.vrVisible;
        const vr_visible = vrVisible;
        dispatch(setVrVisible(!vr_visible));
        if (!vr_visible) {
          //打开VR - 关闭互斥页面UI
          if (editVisible) {
            newPanelState.editVisible = false;
            dispatch(setEditVisible(false));
            dispatch(setEditType(""));
          }
          if (viewVisible) {
            newPanelState.viewVisible = false;
            dispatch(setViewVisible(false));
          }
          if (measureVisible) {
            newPanelState.measureVisible = false;
            dispatch(setMeasureVisible(false));
          }
          if (createModelVisible) {
            newPanelState.createModelVisible = false;
            dispatch(setCreateModelVisible(false));
          }
        }
        break;

      // 测量
      case "measure":
        newPanelState.measureVisible = !newPanelState.measureVisible;
        const measure_visible = measureVisible;
        dispatch(setMeasureVisible(!measure_visible));
        if (!measure_visible) {
          // 打开
          handleGetMeasureList();
          editor.setClickMode(1);

          //关闭互斥页面UI
          if (editVisible) {
            newPanelState.editVisible = false;
            dispatch(setEditVisible(false));
            dispatch(setEditType(""));
          }
          if (viewVisible) {
            newPanelState.viewVisible = false;
            dispatch(setViewVisible(false));
          }
          if (vrVisible) {
            newPanelState.vrVisible = false;
            dispatch(setVrVisible(false));
          }
          if (createModelVisible) {
            newPanelState.createModelVisible = false;
            dispatch(setCreateModelVisible(false));
          }
        } else {
          editor.setClickMode(0);
        }
        break;

      // 创建模型
      case "model":
        newPanelState.createModelVisible = !newPanelState.createModelVisible;
        const create_model_visible = createModelVisible;
        dispatch(setCreateModelVisible(!create_model_visible));
        if (!create_model_visible) {
          //关闭互斥页面UI
          if (editVisible) {
            newPanelState.editVisible = false;
            dispatch(setEditVisible(false));
            dispatch(setEditType(""));
          }
          if (viewVisible) {
            newPanelState.viewVisible = false;
            dispatch(setViewVisible(false));
          }
          if (vrVisible) {
            newPanelState.vrVisible = false;
            dispatch(setVrVisible(false));
          }
          if (measureVisible) {
            newPanelState.measureVisible = false;
            dispatch(setMeasureVisible(false));
          }

          editor.setClickMode(9);
        }
        break;

      // 保存
      case "save":
        editor.save();
        break;
    }

    editor.recordPanelStateChange(oldPanelState, newPanelState);

    // if (item.id === type) {
    //   return handleCloseMenuContent(type)
    //   // return setType('')
    // }
    // setType(item.id)
  };

  const handleCloseMenuContent = (menu) => {
    editor.setClickMode(0);

    // eslint-disable-next-line default-case
    switch (menu) {
      case "tree":
        dispatch(setTreeVisible(false));
        break;

      case "sky":
        dispatch(setSkyVisible(false));
        break;

      case "change":
        dispatch(setViewVisible(false));
        break;

      case "vr":
        dispatch(setVrVisible(false));

        let vrCopy = Object.assign({}, vrData);
        vrCopy.enabled = false;
        vrCopy.position_enabled = false;
        vrCopy.floor_enabled = false;
        let lastData = Object.assign({}, vrCopy);
        dispatch(setVrData(vrCopy));
        editor.VRsetKey(false, false);
        editor.editorOnoff("plane", false, false);
        editor.editorOnoff("position", false, false);
        editor.setClickMode(0);
        break;

      case "measure":
        dispatch(setMeasureVisible(false));
        editor.setClickMode(0);
        break;

      case "model":
        dispatch(setCreateModelVisible(false));
    }
  };

  /*-----------------------------对象树-----------------------------*/
  /**
   * 打开对象树
   * */
  const handleGetTreeList = () => {
    const tree = editor.getMeshTree();
    dispatch(setTreeList(JSON.parse(JSON.stringify(tree))));
  };

  /**
   * 对象树显隐
   * */
  const handleToggleEye = (item, index) => {
    const newTreeList = treeList.map((obj, i) =>
      i === index ? { ...obj, visible: !obj.visible } : obj
    );
    dispatch(setTreeList(newTreeList));
    editor.getNodeVisibleorUnvisible(item.nodeId, !item.visible);
  };

  /**
   * 点击结构树
   * */
  const handleClickTreeItem = (nodeId) => {
    if (editType === "scene" || editType === "model") {
      dispatch(setActiveTreeNodeId([nodeId]));
      editor.clickHierarchy(nodeId);
    }
  };

  /*是否是选中的节点*/
  const isInActiveNodeId = (nodeId) => {
    return activeTreeNodeId.some((item) => item === nodeId);
  };

  /*-----------------------------天空-----------------------------*/
  /**
   * 获取天空数值
   * */
  const handleGetSkyInfo = () => {
    const sunAngle = editor.getSunAngle();
    const ambientIntensity = editor.getAmbientIntensity();
    const ambientColor = editor.getAmbientColor();
    const fogDensity = editor.getFogDensity();
    const fogColor = editor.getFogColor();

    // console.log(sunAngle, ambientIntensity, ambientColor, fogColor, fogDensity)

    const newSkyInfo = { ...skyInfo };
    newSkyInfo.sunAngle = sunAngle;
    newSkyInfo.ambientIntensity = ambientIntensity;
    newSkyInfo.ambientColor = ambientColor;
    newSkyInfo.fogDensity = fogDensity;
    newSkyInfo.fogColor = fogColor;
    dispatch(setSkyInfo(newSkyInfo));
  };

  /**
   * 修改天空slider
   * */
  const handleChangeSkySlider = (type, value) => {
    const newSkyInfo = { ...skyInfo };

    // eslint-disable-next-line default-case
    switch (type) {
      case "sunAngle":
        newSkyInfo.sunAngle = value;
        editor.setSunAngle(value);
        break;
      case "ambientIntensity":
        newSkyInfo.ambientIntensity = value;
        editor.setAmbientIntensity(value);
        break;
      case "fogDensity":
        newSkyInfo.fogDensity = value;
        editor.setFogDensity(value);
        break;
    }

    dispatch(setSkyInfo(newSkyInfo));
  };

  /**
   * 修改天空取色器
   * */
  const handleChangeSkyColor = (type, value) => {
    // eslint-disable-next-line default-case
    switch (type) {
      case "ambientColor":
        editor.setAmbientColor(value);
        dispatch(
          setSkyInfo((prevKey) => ({ ...prevKey, ambientColor: value }))
        );
        break;
      case "fogColor":
        editor.setFogColor(value);
        dispatch(setSkyInfo((prevKey) => ({ ...prevKey, fogColor: value })));
        break;
    }
  };

  /**
   * 点击设置天空天气
   * */
  const handleSetSkyWeather = (weather) => {
    const newSkyInfo = { ...skyInfo };
    newSkyInfo.weather = weather;
    dispatch(setSkyInfo(newSkyInfo));
  };

  /*-----------------------------视图-----------------------------*/
  /**
   * 切换视图
   * */
  const handleClickViewItem = (view) => {
    dispatch(setActiveView(view));
    editor.setupView(view);
  };

  /*-----------------------------VR设置-----------------------------*/
  /**
   * VR 设置 切换
   * */
  const handleChangeVrEnabled = (val, type) => {
    let vrCopy = Object.assign({}, vrData);
    vrCopy[type] = val;

    let lastData;

    if (type === "enabled") {
      editor.VRsetKey(val);
    } else if (type === "floor_enabled") {
      editor.editorOnoff("plane", val);
      editor.setClickMode(7);
      if (vrCopy.position_enabled === true) {
        vrCopy.position_enabled = false;
        // editor.editorOnoff("position", false);
      }
    } else if (type === "position_enabled") {
      editor.editorOnoff("position", val);
      editor.setClickMode(8);
      if (vrCopy.floor_enabled === true) {
        vrCopy.floor_enabled = false;
        // editor.editorOnoff("plane", false);
      }
    }
    lastData = Object.assign({}, vrCopy);
    console.log(lastData);
    dispatch(setVrData(lastData));
  };

  const handleChangeFloorColor = (color) => {
    if (color) {
      dispatch(setVrData((prev) => ({ ...prev, floor_color: color })));
      editor.editorConfirmAndDelect("color", color);
    }
  };

  /**
   * 点击VR设置的按钮
   * */
  const handleClickVrButton = (type, value) => {
    console.log(type, value);
    editor.editorConfirmAndDelect(type, value);
  };

  /*-----------------------------测量-----------------------------*/
  /**
   * 获取全部数据
   * */
  const handleGetMeasureList = () => {
    const measureList = editor.getAllMeasureRecord();
    dispatch(setMeasureList(measureList));
  };

  /**
   * 切换单位
   * */
  const handleSetUnit = (value) => {
    dispatch(setUnit(value));
    setSelectExpanded(false);
    editor.setMeasureUnit(value);
  };

  /**
   * 切换可见性
   * */
  const handleChangeVisible = (id, visible) => {
    editor.setMeasureRecordVisibleById(id, visible);
  };

  /**
   * 删除
   * */
  const handleDeleteMeasure = (id) => {
    editor.removeMeasureRecord(id);
  };

  /**
   * 全部隐藏
   * */
  const handleHiddenAllMeasure = () => {
    const visible = !mVisible;
    dispatch(setMVisible(visible));
    editor.setAllMeasireRecordVisible(visible);
  };

  /**
   * 清空
   * */
  const handleEmptyAllMeasure = () => {
    editor.removeAllMeasureRecords();
  };

  /*-----------------------------创建模型-----------------------------*/
  /**
   * 点击选择创建模型类别
   * */
  const handleClickModelItem = (index) => {
    dispatch(setActiveModelIndex(index));
  };

  /**
   * 点击创建模型确定按钮
   * */
  const handleCertainCreateModel = () => {
    editor.createBasicObject(activeModelIndex);
    // handleCloseMenuContent('model')
    // dispatch(setEditType('scene'))
    // dispatch(setEditVisible(true))
    // editor.setClickMode(2)
  };

  return (
    <div className="right-menu-wrapper">
      {/* 取色器蒙板*/}
      {showColorPickerOverlay && (
        <div
          className="color-picker-overlay"
          onClick={() => {
            setActiveColorPickerId(null);
            setShowColorPickerOverlay(false);
          }}
        ></div>
      )}
      {/*对象树*/}
      {contextHolder}
      <Draggable>
        <div
          className={`content-wrapper blur ${treeVisible ? "show" : "hidden"}`}
        >
          <div className="content-wrapper-header">
            对象树
            <span
              className="close"
              onClick={() => handleCloseMenuContent("tree")}
            ></span>
          </div>
          <div className="content-wrapper-main tree">
            {treeList.map((item, index) => {
              return (
                <div
                  className={`tree-item ${
                    isInActiveNodeId(item.nodeId) ? "active" : ""
                  }`}
                  key={item.nodeId}
                >
                  <span
                    className="text"
                    onClick={() => handleClickTreeItem(item.nodeId)}
                  >
                    {item.name}
                  </span>
                  <span
                    className={`eye ${item.visible ? "" : "no"}`}
                    onClick={() => handleToggleEye(item, index)}
                  ></span>
                </div>
              );
            })}
          </div>
        </div>
      </Draggable>

      {/*天空*/}
      <Draggable>
        <div
          className={`content-wrapper blur ${
            skyVisible ? "block" : "hidden"
          } sky`}
        >
          <div className="content-wrapper-header">
            天空
            <span
              className="close"
              onClick={() => handleCloseMenuContent("sky")}
            ></span>
          </div>
          <div className="content-wrapper-main">
            <div className="weather-setting">
              <div className="slider-item">
                <div className="label">太阳角度</div>
                <div className="slider-wrapper">
                  <Slider
                    className="r-slider"
                    value={skyInfo.sunAngle}
                    min={0}
                    max={1}
                    step={0.01}
                    onChange={(val) => handleChangeSkySlider("sunAngle", val)}
                    // onAfterChange={() =>
                    //   document.getSelection().removeAllRanges()
                    // } // 添加拖拽结束时的文字取消选中
                  />
                </div>
              </div>
              <div className="weather-controller">
                {weatherList.map((item) => {
                  return (
                    <div
                      className={`weather ${item.icon} ${
                        skyInfo.weather === item.id ? "active" : ""
                      }`}
                      key={item.id}
                      onClick={() => handleSetSkyWeather(item.id)}
                    >
                      <span className="icon" />
                      <span className="text">{item.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="slider-item">
              <div className="label">环境光强度</div>
              <div className="slider-wrapper">
                <Slider
                  className="r-slider"
                  value={skyInfo.ambientIntensity}
                  min={0}
                  max={1}
                  step={0.01}
                  onChange={(val) =>
                    handleChangeSkySlider("ambientIntensity", val)
                  }
                  // onAfterChange={() =>
                  //   document.getSelection().removeAllRanges()
                  // } // 添加拖拽结束时的文字取消选中
                />
              </div>
            </div>
            <div className="slider-item">
              <div className="label">雾强度</div>
              <div className="slider-wrapper">
                <Slider
                  className="r-slider"
                  value={skyInfo.fogDensity}
                  min={0}
                  max={1}
                  step={0.01}
                  onChange={(val) => handleChangeSkySlider("fogDensity", val)}
                  // onAfterChange={() =>
                  //   document.getSelection().removeAllRanges()
                  // } // 添加拖拽结束时的文字取消选中
                />
              </div>
            </div>
            <div className="slider-item">
              <div className="label">环境光颜色</div>
              <div className="color-picker-wrapper">
                <RColorPicker
                  color={skyInfo.ambientColor}
                  id="ambientColor"
                  changeColor={(color) =>
                    handleChangeSkyColor("ambientColor", color)
                  }
                  active={activeColorPickerId === "ambientColor"}
                  onOpen={() => {
                    console.log("open");
                    setActiveColorPickerId("ambientColor");
                    setShowColorPickerOverlay(true);
                  }}
                  onClose={() => {
                    setActiveColorPickerId(null);
                    setShowColorPickerOverlay(false);
                  }}
                ></RColorPicker>
              </div>
            </div>
            <div className="slider-item">
              <div className="label">雾颜色</div>
              <div className="color-picker-wrapper">
                <RColorPicker
                  color={skyInfo.fogColor}
                  id="fogColor"
                  changeColor={(color) =>
                    handleChangeSkyColor("fogColor", color)
                  }
                  active={activeColorPickerId === "fogColor"}
                  onOpen={() => {
                    setActiveColorPickerId("fogColor");
                    setShowColorPickerOverlay(true);
                  }}
                  onClose={() => {
                    setActiveColorPickerId(null);
                    setShowColorPickerOverlay(false);
                  }}
                ></RColorPicker>
              </div>
            </div>
          </div>
        </div>
      </Draggable>

      {/*场景*/}
      <Draggable>
        <div
          className={`content-wrapper blur ${
            sceneVisible ? "block" : "hidden"
          }`}
        >
          <div className="content-wrapper-header">
            场景
            <span
              className="close"
              onClick={() => handleCloseMenuContent("scene")}
            ></span>
          </div>
          <div className="content-wrapper-main scene">
            <div className="scene-controller">
              <div className="btn scene"></div>
              <div className="btn delete"></div>
            </div>
            <div className="scene-search">
              <div className="prefix"></div>
              <input type="text" className="scene-search-input" />
            </div>
            <div className="scene-content">
              <div className="scene-item">
                <div className="image-wrapper">
                  <input type="checkbox" />
                </div>
                <div className="text">111</div>
              </div>
              <div className="scene-item">
                <div className="image-wrapper">
                  <input type="checkbox" />
                </div>
                <div className="text">111</div>
              </div>
              <div className="scene-item">
                <div className="image-wrapper">
                  <input type="checkbox" />
                </div>
                <div className="text">111</div>
              </div>
              <div className="scene-item">
                <div className="image-wrapper">
                  <input type="checkbox" />
                </div>
                <div className="text">111</div>
              </div>
              <div className="scene-item">
                <div className="image-wrapper">
                  <input type="checkbox" />
                </div>
                <div className="text">111</div>
              </div>
              <div className="scene-item">
                <div className="image-wrapper">
                  <input type="checkbox" />
                </div>
                <div className="text">111</div>
              </div>
              <div className="scene-item">
                <div className="image-wrapper">
                  <input type="checkbox" />
                </div>
                <div className="text">111</div>
              </div>
            </div>
          </div>
        </div>
      </Draggable>

      {/*视图*/}
      <Draggable>
        <div className={`content-wrapper blur ${viewVisible ? "" : "hidden"}`}>
          <div className="content-wrapper-header">
            视图
            <span
              className="close"
              onClick={() => handleCloseMenuContent("change")}
            ></span>
          </div>
          <div className="content-wrapper-main view">
            {viewList.map((item) => {
              return (
                <div
                  className={`view-item ${
                    item.id === activeView ? "active" : ""
                  }`}
                  key={item.id}
                  onClick={() => handleClickViewItem(item.id)}
                >
                  <div className={`icon ${item.icon}`}></div>
                  <div className="text">{item.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </Draggable>

      {/*VR设置*/}
      <Draggable>
        <div className={`content-wrapper blur ${vrVisible ? "" : "hidden"}`}>
          <div className="content-wrapper-header">
            VR设置
            {/*<Switch checkedChildren="是" unCheckedChildren="否"></Switch>*/}
            <RSwitch
              size="large"
              changeValue={(val) => handleChangeVrEnabled(val, "enabled")}
              checked={vrData && vrData.enabled ? vrData.enabled : false}
            ></RSwitch>
            <span
              className="close"
              onClick={() => handleCloseMenuContent("vr")}
            ></span>
          </div>
          <div
            className={`content-wrapper-main vr 
            ${
              vrData &&
              vrData.hasOwnProperty("enabled") &&
              vrData.enabled === true
                ? ""
                : "hidden"
            }`}
          >
            <div className="vr-setting-wrapper">
              <div className="vr-setting-header">
                地板设置
                <RSwitch
                  size="small"
                  changeValue={(val) =>
                    handleChangeVrEnabled(val, "floor_enabled")
                  }
                  checked={
                    vrData && vrData.floor_enabled
                      ? vrData.floor_enabled
                      : false
                  }
                ></RSwitch>
              </div>
              <div
                className={`${
                  vrData &&
                  vrData.hasOwnProperty("floor_enabled") &&
                  vrData.floor_enabled === true
                    ? ""
                    : "hidden"
                }`}
              >
                <div className="vr-setting-color">
                  <div className="left">
                    <span className="name">颜色</span>
                    <div className="color-picker">
                      <RColorPicker
                        color={vrData.floor_color}
                        id="floorColor"
                        changeColor={(color) => handleChangeFloorColor(color)}
                        active={activeColorPickerId === "floorColor"}
                        onOpen={() => {
                          setActiveColorPickerId("floorColor");
                          setShowColorPickerOverlay(true);
                        }}
                        onClose={() => {
                          setActiveColorPickerId(null);
                          setShowColorPickerOverlay(false);
                        }}
                      ></RColorPicker>
                    </div>
                  </div>
                  <span className="color">{vrData.floor_color}</span>
                </div>
                <div className="vr-setting-footer">
                  <RButton
                    icon="certain"
                    text="确定"
                    handleClick={() => handleClickVrButton("plane", "confirm")}
                  />
                  <RButton
                    icon="empty"
                    text="清空"
                    handleClick={() => handleClickVrButton("plane", "delect")}
                  />
                </div>
              </div>
            </div>
            <div className="vr-setting-wrapper">
              <div className="vr-setting-header">
                位置设置
                <RSwitch
                  size="small"
                  changeValue={(val) =>
                    handleChangeVrEnabled(val, "position_enabled")
                  }
                  checked={
                    vrData && vrData.position_enabled
                      ? vrData.position_enabled
                      : false
                  }
                ></RSwitch>
              </div>
              <div
                className={`${
                  vrData &&
                  vrData.hasOwnProperty("position_enabled") &&
                  vrData.position_enabled === true
                    ? ""
                    : "hidden"
                }`}
              >
                <div className="vr-setting-footer">
                  <RButton
                    icon="certain"
                    text="确定"
                    handleClick={() =>
                      handleClickVrButton("position", "confirm")
                    }
                  />
                  <RButton
                    icon="empty"
                    text="清空"
                    handleClick={() =>
                      handleClickVrButton("position", "delect")
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Draggable>

      {/*测量*/}
      <Draggable>
        <div
          className={`content-wrapper blur ${measureVisible ? "" : "hidden"}`}
        >
          <div className="content-wrapper-header">
            测量
            <span
              className="close"
              onClick={() => handleCloseMenuContent("measure")}
            ></span>
          </div>
          <div className="content-wrapper-main">
            <div className="measure-controller">
              <button className="measure"></button>
              <div
                className={`select-wrapper ${selectExpanded ? "expanded" : ""}`}
              >
                <div
                  className="select-menu"
                  onClick={() => setSelectExpanded(!selectExpanded)}
                >
                  {unit}
                </div>
                <div className="select-options blur">
                  <div className="option" onClick={() => handleSetUnit("m")}>
                    m
                  </div>
                  <div className="option" onClick={() => handleSetUnit("cm")}>
                    cm
                  </div>
                  <div className="option" onClick={() => handleSetUnit("mm")}>
                    mm
                  </div>
                </div>
              </div>
            </div>

            <div className="measure-content">
              {measureList.map((item) => {
                return (
                  <div className="measure-item" key={item.id}>
                    <span
                      className={`eye ${item.visible ? "" : "no"}`}
                      onClick={() =>
                        handleChangeVisible(item.id, !item.visible)
                      }
                    />
                    <span className="name">{item.name}</span>
                    <span className="value">
                      {Number(item.distance).toFixed(2)}
                    </span>
                    <span className="unit">{unit}</span>
                    <span
                      className="del"
                      onClick={() => handleDeleteMeasure(item.id)}
                    />
                  </div>
                );
              })}
            </div>
            <div className="measure-footer">
              <RButton
                icon={`${mVisible ? "no-eye" : "eye"}`}
                text={`全部${mVisible ? "隐藏" : "显示"}`}
                handleClick={() => handleHiddenAllMeasure()}
              />
              <RButton
                icon="empty"
                text="清空"
                handleClick={() => handleEmptyAllMeasure()}
              />
            </div>
          </div>
        </div>
      </Draggable>

      {/*创建模型*/}
      <Draggable>
        <div
          className={`content-wrapper blur ${
            createModelVisible ? "" : "hidden"
          }`}
        >
          <div className="content-wrapper-header">
            创建模型
            <span
              className="close"
              onClick={() => handleCloseMenuContent("model")}
            ></span>
          </div>
          <div className="content-wrapper-main model">
            {createModelList.map((item, index) => {
              return (
                <div
                  className={`model-item ${
                    item.index === activeModelIndex ? "active" : ""
                  }`}
                  key={item.id}
                  onClick={() => handleClickModelItem(item.index)}
                >
                  <span className={`icon ${item.icon}`}></span>
                  <span className="text">{item.label}</span>
                </div>
              );
            })}
            <RButton
              icon="certain"
              text="确定"
              handleClick={() => handleCertainCreateModel()}
            ></RButton>
          </div>
        </div>
      </Draggable>

      <div className="menu-wrapper blur">
        {icons.map((item) => {
          return (
            <div
              className={`menu-item ${type === item.id ? "active" : ""} ${
                item.id === "scene" ? "disabled" : ""
              }`}
              key={item.id}
              onClick={() => handleClickMenuItem(item)}
            >
              <span className={`icon ${item.icon}`}></span>
              <span className="text">{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RightMenu;
